
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta } from "/app/pages/tv.vue?macro=true";
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as authLldLAL6sjaJfinhufTblQ2SvXbV4tXp__siTwYISsSIMeta } from "/app/pages/auth.vue?macro=true";
import { default as helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta } from "/app/pages/help.vue?macro=true";
import { default as loadingkgmfVh5o1nFa_LLHth4G_mWVP7ou0AFnIq_som6NKPYMeta } from "/app/pages/loading.vue?macro=true";
import { default as tv_45helpfdvMk_4537IVF5zGriHJk0lNbGOGjDdQI_Yr7Wypr_45doQMeta } from "/app/pages/tv-help.vue?macro=true";
import { default as check_45inrU_G6efim5rfh1oNmT_45CDqghKh1dZbtkUR7tjebHDKsMeta } from "/app/pages/check-in.vue?macro=true";
import { default as contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta } from "/app/pages/contact-us.vue?macro=true";
import { default as shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta } from "/app/pages/inapp/shop.vue?macro=true";
import { default as mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta } from "/app/pages/mobile-app.vue?macro=true";
import { default as desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta } from "/app/pages/desktop-app.vue?macro=true";
import { default as unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta } from "/app/pages/unsubscribe.vue?macro=true";
import { default as url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta } from "/app/pages/url-checker.vue?macro=true";
import { default as activity_45endY0byUUCUKhkXe8tAsKZRHEG1CkzZElw9UY57Kvh1CD4Meta } from "/app/pages/activity-end.vue?macro=true";
import { default as auth_45success_458mfj2HRC5mm_45IlWBRX1gGiT2wEbzX_45LkDkEt159erMMeta } from "/app/pages/auth-success.vue?macro=true";
import { default as widgetbi9_459Nc_4572BvYIPPSNCXgCXfocqE6MGDQZm7adLMOPoMeta } from "/app/pages/inapp/widget.vue?macro=true";
import { default as _91_46_46_46parent_ids_93Nkt23KRvRSr_45w494C0A1qMObwxUrXEpG8dTYTL_45aGp8Meta } from "/app/pages/s/[share_id]/[...parent_ids].vue?macro=true";
import { default as _91share_id_93zfPB3_45Mn0lSxrIlSxU2Ec48zks_45H1_xakt6YwkPZNuAMeta } from "/app/pages/s/[share_id].vue?macro=true";
import { default as check_45in_45guidevqfd9H21BvDcIQ9M2F48qn24BNsbAlyBWmovQilmPoYMeta } from "/app/pages/check-in-guide.vue?macro=true";
import { default as browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta } from "/app/pages/browser-extension.vue?macro=true";
import { default as indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta } from "/app/pages/help-center/index.vue?macro=true";
import { default as christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta } from "/app/pages/activity/christmas.vue?macro=true";
import { default as favorite_45links_45hubmkbt0qJo6GeVhz4xHayx_451jetd8wc8YZbMrXawrMM2kMeta } from "/app/pages/favorite-links-hub.vue?macro=true";
import { default as indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta } from "/app/pages/policy/update/index.vue?macro=true";
import { default as transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta } from "/app/pages/transparency-report.vue?macro=true";
import { default as compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta } from "/app/pages/activity/compensation.vue?macro=true";
import { default as _91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta } from "/app/pages/help-center/[...slug].vue?macro=true";
import { default as indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta } from "/app/pages/policy/anti-abuse/index.vue?macro=true";
import { default as black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta } from "/app/pages/activity/black-friday-2024.vue?macro=true";
import { default as install_45apk_45troubleshooting6ZERWm72cUXOsEdFxnTs2tK9NgXUUQ9gWErKxIfUW9IMeta } from "/app/pages/install-apk-troubleshooting.vue?macro=true";
import { default as indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta } from "/app/pages/policy/privacy-policy/index.vue?macro=true";
import { default as indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta } from "/app/pages/policy/user-agreement/index.vue?macro=true";
import { default as _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta } from "/app/pages/policy/anti-abuse/2023-08-29.vue?macro=true";
import { default as _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta } from "/app/pages/policy/anti-abuse/2025-09-10.vue?macro=true";
import { default as index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta } from "/app/pages/policy/child-sexual-abuse/index.vue?macro=true";
import { default as _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta } from "/app/pages/policy/privacy-policy/2021-11-08.vue?macro=true";
import { default as _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta } from "/app/pages/policy/privacy-policy/2023-10-14.vue?macro=true";
import { default as _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta } from "/app/pages/policy/privacy-policy/2023-11-06.vue?macro=true";
import { default as index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta } from "/app/pages/policy/membership-agreement/index.vue?macro=true";
import { default as indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta } from "/app/pages/policy/copyright-Infringement/index.vue?macro=true";
import { default as _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta } from "/app/pages/policy/update/anti-abuse/2025-09-10.vue?macro=true";
import { default as _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta } from "/app/pages/policy/child-sexual-abuse/2023-05-23.vue?macro=true";
import { default as _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta } from "/app/pages/policy/child-sexual-abuse/2025-02-12.vue?macro=true";
import { default as user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta } from "/app/pages/policy/user-agreement/user-agreement.vue?macro=true";
import { default as _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta } from "/app/pages/policy/membership-agreement/2022-06-14.vue?macro=true";
import { default as _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta } from "/app/pages/policy/membership-agreement/2023-08-23.vue?macro=true";
import { default as _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta } from "/app/pages/policy/update/privacy-policy/2023-10-14.vue?macro=true";
import { default as _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta } from "/app/pages/policy/update/privacy-policy/2023-11-06.vue?macro=true";
import { default as _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta } from "/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue?macro=true";
import { default as _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta } from "/app/pages/policy/update/membership-agreement/2023-08-23.vue?macro=true";
import { default as copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta } from "/app/pages/policy/copyright-Infringement/copyright-Infringement.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "tv___en-US",
    path: "/en-US/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___es",
    path: "/es/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___id",
    path: "/id/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ja",
    path: "/ja/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ko",
    path: "/ko/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ms",
    path: "/ms/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___pt",
    path: "/pt/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___ru",
    path: "/ru/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___uk",
    path: "/uk/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___zh-CN",
    path: "/zh-CN/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "tv___zh-TW",
    path: "/zh-TW/tv",
    meta: tvZbBHEMddxN166JYe9PLMjUHv_457YHpjvl9xU5VHS8k1sMeta || {},
    component: () => import("/app/pages/tv.vue")
  },
  {
    name: "faq___en-US",
    path: "/en-US/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___id",
    path: "/id/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ja",
    path: "/ja/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ko",
    path: "/ko/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ms",
    path: "/ms/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___pt",
    path: "/pt/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___uk",
    path: "/uk/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___zh-CN",
    path: "/zh-CN/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___zh-TW",
    path: "/zh-TW/faq",
    meta: { ...(faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {}), ...{"middleware":"redirect-faq-hash"} },
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/pages/auth.vue")
  },
  {
    name: "help___en-US",
    path: "/en-US/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___es",
    path: "/es/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___id",
    path: "/id/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ja",
    path: "/ja/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ko",
    path: "/ko/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ms",
    path: "/ms/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___pt",
    path: "/pt/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___ru",
    path: "/ru/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___uk",
    path: "/uk/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___zh-CN",
    path: "/zh-CN/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "help___zh-TW",
    path: "/zh-TW/help",
    meta: helpn3YbEVk_45aN5THD9nFMeyUgEDVwXCt2lV9kw32czFMbcMeta || {},
    component: () => import("/app/pages/help.vue")
  },
  {
    name: "index___en-US",
    path: "/en-US",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ms",
    path: "/ms",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___zh-CN",
    path: "/zh-CN",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___zh-TW",
    path: "/zh-TW",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "loading",
    path: "/loading",
    component: () => import("/app/pages/loading.vue")
  },
  {
    name: "tv-help___en-US",
    path: "/en-US/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___es",
    path: "/es/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___id",
    path: "/id/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ja",
    path: "/ja/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ko",
    path: "/ko/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ms",
    path: "/ms/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___pt",
    path: "/pt/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___ru",
    path: "/ru/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___uk",
    path: "/uk/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___zh-CN",
    path: "/zh-CN/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "tv-help___zh-TW",
    path: "/zh-TW/tv-help",
    component: () => import("/app/pages/tv-help.vue")
  },
  {
    name: "check-in___en-US",
    path: "/en-US/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___es",
    path: "/es/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___id",
    path: "/id/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ja",
    path: "/ja/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ko",
    path: "/ko/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ms",
    path: "/ms/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___pt",
    path: "/pt/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___ru",
    path: "/ru/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___uk",
    path: "/uk/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___zh-CN",
    path: "/zh-CN/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "check-in___zh-TW",
    path: "/zh-TW/check-in",
    component: () => import("/app/pages/check-in.vue")
  },
  {
    name: "contact-us___en-US",
    path: "/en-US/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___es",
    path: "/es/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___id",
    path: "/id/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ja",
    path: "/ja/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ko",
    path: "/ko/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ms",
    path: "/ms/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___pt",
    path: "/pt/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___ru",
    path: "/ru/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___uk",
    path: "/uk/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___zh-CN",
    path: "/zh-CN/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "contact-us___zh-TW",
    path: "/zh-TW/contact-us",
    meta: contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta || {},
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "inapp-shop___en-US",
    path: "/en-US/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___es",
    path: "/es/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___id",
    path: "/id/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ja",
    path: "/ja/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ko",
    path: "/ko/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ms",
    path: "/ms/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___pt",
    path: "/pt/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___ru",
    path: "/ru/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___uk",
    path: "/uk/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___zh-CN",
    path: "/zh-CN/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "inapp-shop___zh-TW",
    path: "/zh-TW/inapp/shop",
    meta: shopHz1Ylv80OXeMlTeTK9npYjyiAGhV5EU2ZGe6GUtD9MMMeta || {},
    component: () => import("/app/pages/inapp/shop.vue")
  },
  {
    name: "mobile-app___en-US",
    path: "/en-US/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___es",
    path: "/es/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___id",
    path: "/id/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ja",
    path: "/ja/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ko",
    path: "/ko/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ms",
    path: "/ms/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___pt",
    path: "/pt/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___ru",
    path: "/ru/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___uk",
    path: "/uk/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___zh-CN",
    path: "/zh-CN/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "mobile-app___zh-TW",
    path: "/zh-TW/mobile-app",
    meta: mobile_45app59VBtRMjhJZEEIBfW0EBQgagWF4_XemyyMSIdXAjqG4Meta || {},
    component: () => import("/app/pages/mobile-app.vue")
  },
  {
    name: "desktop-app___en-US",
    path: "/en-US/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___es",
    path: "/es/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___id",
    path: "/id/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ja",
    path: "/ja/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ko",
    path: "/ko/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ms",
    path: "/ms/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___pt",
    path: "/pt/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___ru",
    path: "/ru/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___uk",
    path: "/uk/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___zh-CN",
    path: "/zh-CN/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "desktop-app___zh-TW",
    path: "/zh-TW/desktop-app",
    meta: desktop_45appBMn_45AkwWxTtzScW4EcSe9Nvi79hDlY5h_454lHkC6c8xYMeta || {},
    component: () => import("/app/pages/desktop-app.vue")
  },
  {
    name: "unsubscribe___en-US",
    path: "/en-US/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___es",
    path: "/es/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___id",
    path: "/id/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ja",
    path: "/ja/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ko",
    path: "/ko/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ms",
    path: "/ms/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___pt",
    path: "/pt/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___ru",
    path: "/ru/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___uk",
    path: "/uk/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___zh-CN",
    path: "/zh-CN/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "unsubscribe___zh-TW",
    path: "/zh-TW/unsubscribe",
    meta: unsubscribeebh8DzTH2Lvk1akPbkuhLH29Bz3mPVQalzfQeu1w4EAMeta || {},
    component: () => import("/app/pages/unsubscribe.vue")
  },
  {
    name: "url-checker___en-US",
    path: "/en-US/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___es",
    path: "/es/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___id",
    path: "/id/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___ja",
    path: "/ja/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___ko",
    path: "/ko/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___ms",
    path: "/ms/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___pt",
    path: "/pt/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___ru",
    path: "/ru/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___uk",
    path: "/uk/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___zh-CN",
    path: "/zh-CN/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "url-checker___zh-TW",
    path: "/zh-TW/url-checker",
    meta: { ...(url_45checkerzJyECxve_45u8fxND5j2OxxJFYS_45TMYVCs4zeiAZp1boAMeta || {}), ...{"middleware":"disable-mobile-platform-card-anchor"} },
    component: () => import("/app/pages/url-checker.vue")
  },
  {
    name: "activity-end___en-US",
    path: "/en-US/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___es",
    path: "/es/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___id",
    path: "/id/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ja",
    path: "/ja/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ko",
    path: "/ko/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ms",
    path: "/ms/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___pt",
    path: "/pt/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___ru",
    path: "/ru/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___uk",
    path: "/uk/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___zh-CN",
    path: "/zh-CN/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "activity-end___zh-TW",
    path: "/zh-TW/activity-end",
    component: () => import("/app/pages/activity-end.vue")
  },
  {
    name: "auth-success___en-US",
    path: "/en-US/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___es",
    path: "/es/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___id",
    path: "/id/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ja",
    path: "/ja/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ko",
    path: "/ko/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ms",
    path: "/ms/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___pt",
    path: "/pt/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___ru",
    path: "/ru/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___uk",
    path: "/uk/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___zh-CN",
    path: "/zh-CN/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "auth-success___zh-TW",
    path: "/zh-TW/auth-success",
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "inapp-widget___en-US",
    path: "/en-US/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___es",
    path: "/es/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___id",
    path: "/id/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ja",
    path: "/ja/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ko",
    path: "/ko/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ms",
    path: "/ms/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___pt",
    path: "/pt/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___ru",
    path: "/ru/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___uk",
    path: "/uk/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___zh-CN",
    path: "/zh-CN/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "inapp-widget___zh-TW",
    path: "/zh-TW/inapp/widget",
    component: () => import("/app/pages/inapp/widget.vue")
  },
  {
    name: "s-share_id",
    path: "/s/:share_id()",
    meta: { ...(_91share_id_93zfPB3_45Mn0lSxrIlSxU2Ec48zks_45H1_xakt6YwkPZNuAMeta || {}), ...{"middleware":"share"} },
    component: () => import("/app/pages/s/[share_id].vue"),
    children: [
  {
    name: "s-share_id-parent_ids",
    path: ":parent_ids(.*)*",
    component: () => import("/app/pages/s/[share_id]/[...parent_ids].vue")
  }
]
  },
  {
    name: "check-in-guide___en-US",
    path: "/en-US/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___es",
    path: "/es/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___id",
    path: "/id/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ja",
    path: "/ja/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ko",
    path: "/ko/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ms",
    path: "/ms/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___pt",
    path: "/pt/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___ru",
    path: "/ru/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___uk",
    path: "/uk/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___zh-CN",
    path: "/zh-CN/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "check-in-guide___zh-TW",
    path: "/zh-TW/check-in-guide",
    component: () => import("/app/pages/check-in-guide.vue")
  },
  {
    name: "browser-extension___en-US",
    path: "/en-US/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___es",
    path: "/es/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___id",
    path: "/id/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ja",
    path: "/ja/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ko",
    path: "/ko/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ms",
    path: "/ms/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___pt",
    path: "/pt/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___ru",
    path: "/ru/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___uk",
    path: "/uk/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___zh-CN",
    path: "/zh-CN/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "browser-extension___zh-TW",
    path: "/zh-TW/browser-extension",
    meta: browser_45extensionu4Lb0u2mpfFB6jtvbWhRS6bIlOmv3an3cqIuN_45JhcsMMeta || {},
    component: () => import("/app/pages/browser-extension.vue")
  },
  {
    name: "help-center___en-US",
    path: "/en-US/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___es",
    path: "/es/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___id",
    path: "/id/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ja",
    path: "/ja/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ko",
    path: "/ko/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ms",
    path: "/ms/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___pt",
    path: "/pt/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___ru",
    path: "/ru/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___uk",
    path: "/uk/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___zh-CN",
    path: "/zh-CN/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "help-center___zh-TW",
    path: "/zh-TW/help-center",
    meta: indexq3pANToS4bjqWeSNBRadHXUNpQz6CypY7PmFVZ7RtOoMeta || {},
    component: () => import("/app/pages/help-center/index.vue")
  },
  {
    name: "activity-christmas___en-US",
    path: "/en-US/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___es",
    path: "/es/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___id",
    path: "/id/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ja",
    path: "/ja/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ko",
    path: "/ko/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ms",
    path: "/ms/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___pt",
    path: "/pt/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___ru",
    path: "/ru/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___uk",
    path: "/uk/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___zh-CN",
    path: "/zh-CN/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "activity-christmas___zh-TW",
    path: "/zh-TW/activity/christmas",
    meta: { ...(christmas33vTVEHcsjPR5tONLj0QN7MOV38waDe0rrsCYo_oFxwMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/christmas.vue")
  },
  {
    name: "favorite-links-hub___en-US",
    path: "/en-US/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___es",
    path: "/es/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___id",
    path: "/id/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ja",
    path: "/ja/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ko",
    path: "/ko/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ms",
    path: "/ms/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___pt",
    path: "/pt/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___ru",
    path: "/ru/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___uk",
    path: "/uk/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___zh-CN",
    path: "/zh-CN/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "favorite-links-hub___zh-TW",
    path: "/zh-TW/favorite-links-hub",
    component: () => import("/app/pages/favorite-links-hub.vue")
  },
  {
    name: "policy-update___en-US",
    path: "/en-US/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___es",
    path: "/es/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___id",
    path: "/id/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ja",
    path: "/ja/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ko",
    path: "/ko/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ms",
    path: "/ms/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___pt",
    path: "/pt/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___ru",
    path: "/ru/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___uk",
    path: "/uk/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___zh-CN",
    path: "/zh-CN/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "policy-update___zh-TW",
    path: "/zh-TW/policy/update",
    meta: indexJoGvNfxNSYKpUrOccEzpf4Ihzxx7anels1Fmwp3trekMeta || {},
    component: () => import("/app/pages/policy/update/index.vue")
  },
  {
    name: "transparency-report___en-US",
    path: "/en-US/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___es",
    path: "/es/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___id",
    path: "/id/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___ja",
    path: "/ja/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___ko",
    path: "/ko/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___ms",
    path: "/ms/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___pt",
    path: "/pt/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___ru",
    path: "/ru/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___uk",
    path: "/uk/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___zh-CN",
    path: "/zh-CN/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "transparency-report___zh-TW",
    path: "/zh-TW/transparency-report",
    meta: transparency_45report1YSGbuqB3hBV4K9SThIBj_68AzgrDuU_dBPLu_45RL1uAMeta || {},
    component: () => import("/app/pages/transparency-report.vue")
  },
  {
    name: "activity-compensation___en-US",
    path: "/en-US/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___es",
    path: "/es/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___id",
    path: "/id/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ja",
    path: "/ja/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ko",
    path: "/ko/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ms",
    path: "/ms/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___pt",
    path: "/pt/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___ru",
    path: "/ru/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___uk",
    path: "/uk/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___zh-CN",
    path: "/zh-CN/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "activity-compensation___zh-TW",
    path: "/zh-TW/activity/compensation",
    meta: { ...(compensationijkyTAr7_Mnu18U9wc8FNmo0DixvmNX0zEUH4KLTV0UMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/compensation.vue")
  },
  {
    name: "help-center-slug___en-US",
    path: "/en-US/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___es",
    path: "/es/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___id",
    path: "/id/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ja",
    path: "/ja/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ko",
    path: "/ko/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ms",
    path: "/ms/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___pt",
    path: "/pt/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___ru",
    path: "/ru/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___uk",
    path: "/uk/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___zh-CN",
    path: "/zh-CN/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "help-center-slug___zh-TW",
    path: "/zh-TW/help-center/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93LQRWRT4FU9_LR__45KaBpHW5hsPC_45S9mMwsGwo_uQpihUMeta || {}), ...{"middleware":"help-center-default-dir"} },
    component: () => import("/app/pages/help-center/[...slug].vue")
  },
  {
    name: "policy-anti-abuse___en-US",
    path: "/en-US/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___es",
    path: "/es/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___id",
    path: "/id/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ja",
    path: "/ja/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ko",
    path: "/ko/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ms",
    path: "/ms/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___pt",
    path: "/pt/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___ru",
    path: "/ru/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___uk",
    path: "/uk/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___zh-CN",
    path: "/zh-CN/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "policy-anti-abuse___zh-TW",
    path: "/zh-TW/policy/anti-abuse",
    meta: indexmtO9SwArZlUdh9sjVFSrSVgpi7ZueWCFia0wDjz7hJ4Meta || {},
    component: () => import("/app/pages/policy/anti-abuse/index.vue")
  },
  {
    name: "black-friday___en-US",
    path: "/en-US/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___es",
    path: "/es/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___id",
    path: "/id/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ja",
    path: "/ja/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ko",
    path: "/ko/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ms",
    path: "/ms/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___pt",
    path: "/pt/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___ru",
    path: "/ru/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___uk",
    path: "/uk/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___zh-CN",
    path: "/zh-CN/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "black-friday___zh-TW",
    path: "/zh-TW/activity/black-friday",
    meta: { ...(black_45friday_452024sqCwc1lkl36PRvQhelTNP0thDDgYt_45ratjEFy9HENPQMeta || {}), ...{"middleware":"activity-end"} },
    component: () => import("/app/pages/activity/black-friday-2024.vue")
  },
  {
    name: "install-apk-troubleshooting___en-US",
    path: "/en-US/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___es",
    path: "/es/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___id",
    path: "/id/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ja",
    path: "/ja/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ko",
    path: "/ko/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ms",
    path: "/ms/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___pt",
    path: "/pt/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___ru",
    path: "/ru/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___uk",
    path: "/uk/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___zh-CN",
    path: "/zh-CN/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "install-apk-troubleshooting___zh-TW",
    path: "/zh-TW/install-apk-troubleshooting",
    component: () => import("/app/pages/install-apk-troubleshooting.vue")
  },
  {
    name: "policy-privacy-policy___en-US",
    path: "/en-US/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___es",
    path: "/es/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___id",
    path: "/id/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ja",
    path: "/ja/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ko",
    path: "/ko/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ms",
    path: "/ms/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___pt",
    path: "/pt/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___ru",
    path: "/ru/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___uk",
    path: "/uk/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___zh-CN",
    path: "/zh-CN/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-privacy-policy___zh-TW",
    path: "/zh-TW/policy/privacy-policy",
    meta: indexuSTwiRH7BMUui0R_cQSAD_45Dl3T13id6Ox_45aQ2bygc3AMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/index.vue")
  },
  {
    name: "policy-user-agreement___en-US",
    path: "/en-US/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___es",
    path: "/es/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___id",
    path: "/id/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ja",
    path: "/ja/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ko",
    path: "/ko/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ms",
    path: "/ms/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___pt",
    path: "/pt/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___ru",
    path: "/ru/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___uk",
    path: "/uk/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___zh-CN",
    path: "/zh-CN/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-user-agreement___zh-TW",
    path: "/zh-TW/policy/user-agreement",
    meta: indexFukFjnEnDs6h39NeOysqsEBwDEUJBS2osXNvhih2EVwMeta || {},
    component: () => import("/app/pages/policy/user-agreement/index.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___en-US",
    path: "/en-US/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___es",
    path: "/es/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___id",
    path: "/id/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___ja",
    path: "/ja/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___ko",
    path: "/ko/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___ms",
    path: "/ms/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___pt",
    path: "/pt/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___ru",
    path: "/ru/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___uk",
    path: "/uk/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___zh-CN",
    path: "/zh-CN/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2023-08-29___zh-TW",
    path: "/zh-TW/policy/anti-abuse/2023-08-29",
    meta: _2023_4508_452965BoefuOMKTYxDpE1uGw_45RAx3KmbTqIT60VZw2AqwroMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2023-08-29.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___en-US",
    path: "/en-US/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___es",
    path: "/es/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___id",
    path: "/id/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___ja",
    path: "/ja/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___ko",
    path: "/ko/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___ms",
    path: "/ms/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___pt",
    path: "/pt/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___ru",
    path: "/ru/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___uk",
    path: "/uk/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___zh-CN",
    path: "/zh-CN/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-anti-abuse-2025-09-10___zh-TW",
    path: "/zh-TW/policy/anti-abuse/2025-09-10",
    meta: _2025_4509_4510R0rODCLcVM9bb0iDLSIQJU5tcsy5ju20_459IO4P8BZRQMeta || {},
    component: () => import("/app/pages/policy/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-child-sexual-abuse___en-US",
    path: "/en-US/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___es",
    path: "/es/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___id",
    path: "/id/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ja",
    path: "/ja/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ko",
    path: "/ko/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ms",
    path: "/ms/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___pt",
    path: "/pt/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___ru",
    path: "/ru/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___uk",
    path: "/uk/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___zh-CN",
    path: "/zh-CN/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-child-sexual-abuse___zh-TW",
    path: "/zh-TW/policy/child-sexual-abuse",
    meta: index01YsGr_45VUFAecIFk_45ZiXom7LQqGinPOInhHIikGEIawMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/index.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___en-US",
    path: "/en-US/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___es",
    path: "/es/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___id",
    path: "/id/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ja",
    path: "/ja/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ko",
    path: "/ko/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ms",
    path: "/ms/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___pt",
    path: "/pt/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___ru",
    path: "/ru/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___uk",
    path: "/uk/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___zh-CN",
    path: "/zh-CN/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2021-11-08___zh-TW",
    path: "/zh-TW/policy/privacy-policy/2021-11-08",
    meta: _2021_4511_4508VZu75ada0K7YMviLDS_45QyNmTMbuO_45CQr3TD9aGvDmqUMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2021-11-08.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___en-US",
    path: "/en-US/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___es",
    path: "/es/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___id",
    path: "/id/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ja",
    path: "/ja/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ko",
    path: "/ko/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ms",
    path: "/ms/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___pt",
    path: "/pt/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___ru",
    path: "/ru/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___uk",
    path: "/uk/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___zh-CN",
    path: "/zh-CN/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-10-14___zh-TW",
    path: "/zh-TW/policy/privacy-policy/2023-10-14",
    meta: _2023_4510_4514Vs03eD0XupQXC4cUukZDje_c3fLGpv4WkBvNEiCS7NoMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___en-US",
    path: "/en-US/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___es",
    path: "/es/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___id",
    path: "/id/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ja",
    path: "/ja/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ko",
    path: "/ko/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ms",
    path: "/ms/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___pt",
    path: "/pt/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___ru",
    path: "/ru/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___uk",
    path: "/uk/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___zh-CN",
    path: "/zh-CN/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-privacy-policy-2023-11-06___zh-TW",
    path: "/zh-TW/policy/privacy-policy/2023-11-06",
    meta: _2023_4511_4506B2ypCq7onRI20T6xjKeQkweb2LZDKlHHOzXcAOerAygMeta || {},
    component: () => import("/app/pages/policy/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-membership-agreement___en-US",
    path: "/en-US/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___es",
    path: "/es/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___id",
    path: "/id/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ja",
    path: "/ja/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ko",
    path: "/ko/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ms",
    path: "/ms/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___pt",
    path: "/pt/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___ru",
    path: "/ru/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___uk",
    path: "/uk/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___zh-CN",
    path: "/zh-CN/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-membership-agreement___zh-TW",
    path: "/zh-TW/policy/membership-agreement",
    meta: index37D_eglnUu0FNDZ_45Tt3IdGM_cnVBOZRKWWK_EgFqdpMMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___en-US",
    path: "/en-US/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___es",
    path: "/es/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___id",
    path: "/id/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ja",
    path: "/ja/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ko",
    path: "/ko/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ms",
    path: "/ms/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___pt",
    path: "/pt/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___ru",
    path: "/ru/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___uk",
    path: "/uk/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___zh-CN",
    path: "/zh-CN/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-copyright-Infringement___zh-TW",
    path: "/zh-TW/policy/copyright-Infringement",
    meta: indexjotCWSI_45pCDt20P26lZU9Ro5O7hLA6Vg5f7Noj_45AITMMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/index.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___en-US",
    path: "/en-US/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___es",
    path: "/es/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___id",
    path: "/id/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___ja",
    path: "/ja/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___ko",
    path: "/ko/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___ms",
    path: "/ms/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___pt",
    path: "/pt/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___ru",
    path: "/ru/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___uk",
    path: "/uk/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___zh-CN",
    path: "/zh-CN/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-update-anti-abuse-2025-09-10___zh-TW",
    path: "/zh-TW/policy/update/anti-abuse/2025-09-10",
    meta: _2025_4509_4510JatKxwdju_w_45iWwr17pERlHVgVkWPiVBOSufaff6WgMMeta || {},
    component: () => import("/app/pages/policy/update/anti-abuse/2025-09-10.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___en-US",
    path: "/en-US/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___es",
    path: "/es/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___id",
    path: "/id/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ja",
    path: "/ja/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ko",
    path: "/ko/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ms",
    path: "/ms/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___pt",
    path: "/pt/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___ru",
    path: "/ru/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___uk",
    path: "/uk/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___zh-CN",
    path: "/zh-CN/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2023-05-23___zh-TW",
    path: "/zh-TW/policy/child-sexual-abuse/2023-05-23",
    meta: _2023_4505_4523qU7f344mcocn8yRxsckUPl_45OofE96xSXMhiGVWVAWZsMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2023-05-23.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___en-US",
    path: "/en-US/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___es",
    path: "/es/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___id",
    path: "/id/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ja",
    path: "/ja/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ko",
    path: "/ko/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ms",
    path: "/ms/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___pt",
    path: "/pt/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___ru",
    path: "/ru/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___uk",
    path: "/uk/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___zh-CN",
    path: "/zh-CN/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-child-sexual-abuse-2025-02-12___zh-TW",
    path: "/zh-TW/policy/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512tDjrAC8C2XrcpFLFHdOBkY_B0S8X_SDHkgqVIaMISakMeta || {},
    component: () => import("/app/pages/policy/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___en-US",
    path: "/en-US/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___es",
    path: "/es/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___id",
    path: "/id/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ja",
    path: "/ja/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ko",
    path: "/ko/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ms",
    path: "/ms/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___pt",
    path: "/pt/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___ru",
    path: "/ru/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___uk",
    path: "/uk/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___zh-CN",
    path: "/zh-CN/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-user-agreement-user-agreement___zh-TW",
    path: "/zh-TW/policy/user-agreement/user-agreement",
    meta: user_45agreementlruBiqxKq5FjAZuOg_45eRRGlDGAXwwXCrqijQ56ut0FgMeta || {},
    component: () => import("/app/pages/policy/user-agreement/user-agreement.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___en-US",
    path: "/en-US/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___es",
    path: "/es/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___id",
    path: "/id/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ja",
    path: "/ja/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ko",
    path: "/ko/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ms",
    path: "/ms/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___pt",
    path: "/pt/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___ru",
    path: "/ru/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___uk",
    path: "/uk/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___zh-CN",
    path: "/zh-CN/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2022-06-14___zh-TW",
    path: "/zh-TW/policy/membership-agreement/2022-06-14",
    meta: _2022_4506_4514VhZWn9yXEkLxTmnSefRqbB_45l51Zk8WHj9aElExMCVVEMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2022-06-14.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___en-US",
    path: "/en-US/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___es",
    path: "/es/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___id",
    path: "/id/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ja",
    path: "/ja/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ko",
    path: "/ko/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ms",
    path: "/ms/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___pt",
    path: "/pt/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___ru",
    path: "/ru/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___uk",
    path: "/uk/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___zh-CN",
    path: "/zh-CN/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-membership-agreement-2023-08-23___zh-TW",
    path: "/zh-TW/policy/membership-agreement/2023-08-23",
    meta: _2023_4508_4523jEVoHiOtmH6pCRgiZDdMRag4x0_45H5Gdwzhq5QZ4AWhoMeta || {},
    component: () => import("/app/pages/policy/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___en-US",
    path: "/en-US/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___es",
    path: "/es/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___id",
    path: "/id/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ja",
    path: "/ja/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ko",
    path: "/ko/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ms",
    path: "/ms/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___pt",
    path: "/pt/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___ru",
    path: "/ru/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___uk",
    path: "/uk/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___zh-CN",
    path: "/zh-CN/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-10-14___zh-TW",
    path: "/zh-TW/policy/update/privacy-policy/2023-10-14",
    meta: _2023_4510_4514EIlx6Td7doYrAZV3rEpRGiUQzQGBqwGPY69zN_45wDuDIMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-10-14.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___en-US",
    path: "/en-US/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___es",
    path: "/es/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___id",
    path: "/id/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ja",
    path: "/ja/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ko",
    path: "/ko/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ms",
    path: "/ms/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___pt",
    path: "/pt/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___ru",
    path: "/ru/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___uk",
    path: "/uk/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___zh-CN",
    path: "/zh-CN/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-privacy-policy-2023-11-06___zh-TW",
    path: "/zh-TW/policy/update/privacy-policy/2023-11-06",
    meta: _2023_4511_45067tY_8_45BBufvetdcj4xEWG1Be1RK4eP6MK4ixmKVMqQsMeta || {},
    component: () => import("/app/pages/policy/update/privacy-policy/2023-11-06.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___en-US",
    path: "/en-US/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___es",
    path: "/es/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___id",
    path: "/id/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ja",
    path: "/ja/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ko",
    path: "/ko/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ms",
    path: "/ms/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___pt",
    path: "/pt/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___ru",
    path: "/ru/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___uk",
    path: "/uk/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___zh-CN",
    path: "/zh-CN/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-child-sexual-abuse-2025-02-12___zh-TW",
    path: "/zh-TW/policy/update/child-sexual-abuse/2025-02-12",
    meta: _2025_4502_4512uY6DEvsbswcd4_45fUcooLbLJxo3j1tlJxHdlJLDkdwtQMeta || {},
    component: () => import("/app/pages/policy/update/child-sexual-abuse/2025-02-12.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___en-US",
    path: "/en-US/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___es",
    path: "/es/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___id",
    path: "/id/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ja",
    path: "/ja/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ko",
    path: "/ko/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ms",
    path: "/ms/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___pt",
    path: "/pt/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___ru",
    path: "/ru/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___uk",
    path: "/uk/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___zh-CN",
    path: "/zh-CN/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-update-membership-agreement-2023-08-23___zh-TW",
    path: "/zh-TW/policy/update/membership-agreement/2023-08-23",
    meta: _2023_4508_45231FeQFs3fDXClc_45Tw_45TrTeLxs2M5YL28wwaHHEiQmzfQMeta || {},
    component: () => import("/app/pages/policy/update/membership-agreement/2023-08-23.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___en-US",
    path: "/en-US/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___es",
    path: "/es/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___id",
    path: "/id/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ja",
    path: "/ja/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ko",
    path: "/ko/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ms",
    path: "/ms/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___pt",
    path: "/pt/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___ru",
    path: "/ru/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___uk",
    path: "/uk/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___zh-CN",
    path: "/zh-CN/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: "policy-copyright-Infringement-copyright-Infringement___zh-TW",
    path: "/zh-TW/policy/copyright-Infringement/copyright-Infringement",
    meta: copyright_45InfringementFkdeG6kYBfYvUfm3jXjC3ZTmfG_45dSzDyKaFLctGD8HAMeta || {},
    component: () => import("/app/pages/policy/copyright-Infringement/copyright-Infringement.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]